import { PerAccountLocalStorage, StorageKeys } from '../../services/PerAccountLocalStorage';

const STORAGE_KEY = 'noornote_bookmarks_addon_enabled';

export function isBookmarksEnabled(): boolean {
  const perAccount = PerAccountLocalStorage.getInstance().get<boolean | null>(
    StorageKeys.BOOKMARKS_ADDON_ENABLED, null
  );
  if (perAccount !== null) return perAccount;
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

export function setBookmarksEnabled(enabled: boolean): void {
  PerAccountLocalStorage.getInstance().set(StorageKeys.BOOKMARKS_ADDON_ENABLED, enabled);
  localStorage.setItem(STORAGE_KEY, 'false');
}
